import { render } from "./DisappearingProfile.vue?vue&type=template&id=04dd0eac"
import script from "./DisappearingProfile.vue?vue&type=script&lang=js"
export * from "./DisappearingProfile.vue?vue&type=script&lang=js"

import "./DisappearingProfile.vue?vue&type=style&index=0&id=04dd0eac&lang=css"

import exportComponent from "E:\\Work\\Tabnova SPA\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__